<div class="s-section__btn" style="text-align: center">
  <a [href]="component.content.url" target="_blank" class="c-btn is-primary">{{component.content.name}}</a>
</div>

